module.exports = __webpack_public_path__ + "static/media/front.810aba54.jpg";